import EmailSignUpForm from './EmailSignUpForm';
import OneTimeCodeForm from './OneTimeCodeForm';

import { useAffiliateSelector, useAffiliateDispatch } from '@/store/affiliate';
import { forms, switchAuthForm, updateEmail } from '@/store/affiliate/authFormSlice';
import { applyCodeToProfile } from '@/store/affiliate/couponSlice';
import { switchToPaymentMethodsStep, switchToPlansStep } from '@/store/affiliate/stepsSlice';
import { sendOneTimeCodeEmailRequest } from '@/utils/api/login';
import { saveOTCEmail } from '@/utils/otcStorage';

const AuthFormSwitch = () => {
  const { currentForm, email, code, isCouponRedeemed, selectedPlanSku } = useAffiliateSelector((state) => ({
    ...state.authForm,
    code: state.coupon.code,
    isCouponRedeemed: state.coupon.isRedeemed,
    selectedPlanSku: state.plans.selectedPlan?.sku as string,
  }));
  const dispatch = useAffiliateDispatch();

  const onReturnToEmailForm = () => dispatch(switchAuthForm(forms.emailSignUpForm));

  const sendOTCEmailRequest = (emailAdress: string) => sendOneTimeCodeEmailRequest(emailAdress, selectedPlanSku, code);

  switch (currentForm) {
    case forms.emailSignUpForm:
      const onEmailSignUpFormSubmit = (emailValue: string) => {
        saveOTCEmail(emailValue);
        dispatch(updateEmail(emailValue));
        dispatch(switchAuthForm(forms.oneTimeCodeForm));
      };

      return (
        <EmailSignUpForm
          presetEmail={email}
          selectedPlanSku={selectedPlanSku}
          sendOTCRequest={sendOTCEmailRequest}
          onSubmit={onEmailSignUpFormSubmit}
          onBackButtonClick={() => dispatch(switchToPlansStep())}
        />
      );

    case forms.oneTimeCodeForm:
      const onAuthSuccess = () => {
        if (code && !isCouponRedeemed) {
          void dispatch(applyCodeToProfile(code));
        }

        dispatch(switchToPaymentMethodsStep());
      };

      return (
        <OneTimeCodeForm
          email={email}
          sendOTCRequest={sendOTCEmailRequest}
          onBackButtonClick={onReturnToEmailForm}
          onAuthSuccess={onAuthSuccess}
        />
      );

    default:
      return null;
  }
};

export default AuthFormSwitch;
